import { render } from "./LeaveBalance.vue?vue&type=template&id=56c2fc4a&scoped=true"
import script from "./LeaveBalance.vue?vue&type=script&lang=js"
export * from "./LeaveBalance.vue?vue&type=script&lang=js"

import "./LeaveBalance.vue?vue&type=style&index=0&id=56c2fc4a&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c2fc4a"]])

export default __exports__